import React from "react";
import { CircularProgress } from "@mui/material";

const Spinner = () => {
  return <CircularProgress size={24} sx={{ color: "white" }} />;
};

export default Spinner;
